import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppFab } from "./WhatsAppFab";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="grain min-h-screen bg-[#09090b] relative">
      <Navbar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
};
